import { PromptDataType } from "../types/prompt-model";

export const GetFilterDataTypeString = (filterDataType: PromptDataType) => {
  switch (filterDataType) {
    case 1:
      return "Yes / No";
    case 2:
      return "List of Values";
    case 3:
      return "Range of Values";
    case 4:
      return "Text";
    case 5:
      return "Generative";
    case 6:
      return "Date";
    default:
      return "Unknown";
  }
};
